import { GLOBAL_SSO } from "src/common/constants";
import { GlobalSsoLinksAction } from "../reducers/globalSsoLinks";
import { SSOLinkI } from "src/types/SSOLink";

export const GLOBAL_SSO_SET_DATA = `${GLOBAL_SSO}_SET_DATA` as const;

export const setGlobalSSOLinks = (
  payload: SSOLinkI[]
): GlobalSsoLinksAction => ({
  type: GLOBAL_SSO_SET_DATA,
  payload,
});
